import { useActiveStation } from '../../../core/stations/hooks/useActiveStation';

export function useLiveMentionsEnabledForActiveStation() {
  return Boolean(useActiveStation().featuresConfig?.audit?.liveMentionsEnabled);
}
